import React from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const ConnectLogbookInfo = () => {
    return (
        <Stack alignItems="center">
            <Typography>
                Connect a tracklog to your desired logbook entry by clicking the
                link icon.
            </Typography>
        </Stack>
    );
};

export default ConnectLogbookInfo;
